module.exports = __webpack_public_path__ + "img/avator.bf7988a6.jpg";